import React from 'react';

const GI_2048 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" className="w-full h-full">
    <rect x="10" y="10" width="180" height="180" rx="15" fill="#6366f1" />
    <rect x="25" y="25" width="70" height="70" rx="8" fill="#c7d2fe" />
    <text x="45" y="75" fill="#312e81" fontSize="32" fontWeight="bold">2</text>
    <rect x="105" y="25" width="70" height="70" rx="8" fill="#a5b4fc" />
    <text x="120" y="75" fill="#312e81" fontSize="32" fontWeight="bold">4</text>
    <rect x="25" y="105" width="70" height="70" rx="8" fill="#818cf8" />
    <text x="40" y="155" fill="#312e81" fontSize="32" fontWeight="bold">8</text>
    <rect x="105" y="105" width="70" height="70" rx="8" fill="#4f46e5" />
    <text x="115" y="155" fill="#fff" fontSize="32" fontWeight="bold">16</text>
  </svg>
);

const GI_Memory = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" className="w-full h-full">
    <rect x="10" y="10" width="180" height="180" rx="15" fill="#8b5cf6" />
    <rect x="30" y="30" width="60" height="60" rx="8" fill="#fff" stroke="#c4b5fd" strokeWidth="4"/>
    <rect x="110" y="30" width="60" height="60" rx="8" fill="#fff" stroke="#c4b5fd" strokeWidth="4"/>
    <rect x="30" y="110" width="60" height="60" rx="8" fill="#ddd6fe" stroke="#c4b5fd" strokeWidth="4"/>
    <rect x="110" y="110" width="60" height="60" rx="8" fill="#fff" stroke="#c4b5fd" strokeWidth="4"/>
    <path d="M45 50 L75 80 L45 80 Z" fill="#7c3aed"/>
    <circle cx="140" cy="60" r="15" fill="#7c3aed"/>
  </svg>
);

const GI_TicTacToe = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" className="w-full h-full">
    <rect x="10" y="10" width="180" height="180" rx="15" fill="#ec4899" />
    <line x1="70" y1="30" x2="70" y2="170" stroke="#fff" strokeWidth="4"/>
    <line x1="130" y1="30" x2="130" y2="170" stroke="#fff" strokeWidth="4"/>
    <line x1="30" y1="70" x2="170" y2="70" stroke="#fff" strokeWidth="4"/>
    <line x1="30" y1="130" x2="170" y2="130" stroke="#fff" strokeWidth="4"/>
    <path d="M45 45 L85 85 M85 45 L45 85" stroke="#fce7f3" strokeWidth="6" strokeLinecap="round"/>
    <circle cx="130" cy="130" r="20" stroke="#fce7f3" strokeWidth="6" fill="none"/>
  </svg>
);

const GI_Sudoku = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" className="w-full h-full">
    <rect x="10" y="10" width="180" height="180" rx="15" fill="#06b6d4" />
    <g fill="none" stroke="#cffafe" strokeWidth="2">
      <rect x="30" y="30" width="140" height="140"/>
      <line x1="30" y1="77" x2="170" y2="77"/>
      <line x1="30" y1="123" x2="170" y2="123"/>
      <line x1="77" y1="30" x2="77" y2="170"/>
      <line x1="123" y1="30" x2="123" y2="170"/>
      <line x1="30" y1="77" x2="170" y2="77" strokeWidth="4"/>
      <line x1="30" y1="123" x2="170" y2="123" strokeWidth="4"/>
      <line x1="77" y1="30" x2="77" y2="170" strokeWidth="4"/>
      <line x1="123" y1="30" x2="123" y2="170" strokeWidth="4"/>
    </g>
    <text x="47" y="65" fill="#fff" fontSize="24" fontWeight="bold">5</text>
    <text x="93" y="65" fill="#fff" fontSize="24" fontWeight="bold">3</text>
    <text x="140" y="110" fill="#fff" fontSize="24" fontWeight="bold">8</text>
    <text x="47" y="155" fill="#fff" fontSize="24" fontWeight="bold">4</text>
  </svg>
);

const GI_Chess = () => (  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" className="w-full h-full">
  {/* Background */}
  <rect x="10" y="10" width="180" height="180" rx="15" fill="#8b5cf6" />
  
  {/* Chessboard */}
  <g stroke="#f5f3ff" strokeWidth="2" fill="none">
    <rect x="40" y="40" width="120" height="120" />
    
    {/* Board squares */}
    <g fill="#f5f3ff">
      <rect x="40" y="40" width="30" height="30" />
      <rect x="100" y="40" width="30" height="30" />
      <rect x="70" y="70" width="30" height="30" />
      <rect x="130" y="70" width="30" height="30" />
      <rect x="40" y="100" width="30" height="30" />
      <rect x="100" y="100" width="30" height="30" />
      <rect x="70" y="130" width="30" height="30" />
      <rect x="130" y="130" width="30" height="30" />
    </g>
  </g>
  
  {/* Chess pieces */}
  <g fill="#ffffff">
    {/* White King */}
    <path d="M55,60 L55,50 L65,50 L65,60 L60,55 Z" strokeWidth="1" stroke="#8b5cf6" />
    
    {/* White Queen */}
    <circle cx="85" cy="55" r="7" strokeWidth="1" stroke="#8b5cf6" />
    
    {/* White Rook */}
    <path d="M110,50 L110,60 L120,60 L120,50 L117,55 L113,55 Z" strokeWidth="1" stroke="#8b5cf6" />
    
    {/* White Pawn */}
    <circle cx="145" cy="85" r="6" strokeWidth="1" stroke="#8b5cf6" />
  </g>
  
  {/* Black pieces */}
  <g fill="#8b5cf6" stroke="#ffffff" strokeWidth="1">
    {/* Black Knight */}
    <path d="M55,115 C55,115 53,110 58,110 C63,110 65,115 60,120 Z" />
    
    {/* Black Bishop */}
    <path d="M85,115 L80,120 L90,120 Z" />
    
    {/* Black Rook */}
    <path d="M110,110 L110,120 L120,120 L120,110 L117,115 L113,115 Z" />
    
    {/* Black Pawn */}
    <circle cx="145" cy="145" r="6" />
  </g>
</svg>)

const GameIcons = {
  '1.1': GI_2048,
  '1.2': GI_Memory,
  '1.3': GI_TicTacToe,
  '1.4': GI_Sudoku,
  '1.5': GI_Chess
};

export default GameIcons;